let sortedPages = (state, type) => {
  let pagesType = state.pages[type];
  let query = pagesType.query.toLowerCase() || "";
  const newPagesFiltered = state.pages[type].list
  .filter(item => {
    const id = item.id + "";
    return item.title.toLowerCase().includes(query) || (item?.itemsName?.toLowerCase().includes(query)) || id.includes(query);
  }).sort((a, b) => {
    if(a.published) return -1;
    if(b.published) return 1;
    return 1;
  });
  return newPagesFiltered;
};

const getters = {
  sortedArticlePages: state => {
    return sortedPages(state, "articlepages");
  },
  sortedProductPages: state => {
    return sortedPages(state, "productpages");
  },
  isNeedToUnpublishProductPage: state => publishedPageCount => {
    return publishedPageCount > state.pages['productpages'].limit;
  },
  isNeedToUnpublishArticlePage: state => publishedPageCount =>{
    return publishedPageCount > state.pages['articlepages'].limit;
  },
};

export default getters;
